import React, { useEffect } from 'react';
import { getPlatform, noop } from '../utils';
import { LinkText, Paragraph } from '@mediahuis/chameleon-react';
import Header from '../Header';
import { PLATFORM, URL_LOGOFF, URL_LOGON } from '../constants';
import { getLanguage } from './language';
import { ACTIVATION_HAS_ACCESS } from '../constants/steps';
import { trackingLogOffVariables, trackingOnMountVariables } from '../trackingVariables';
import AboPaper from '../components/AboPaper';
var isActivationPage = /activeer/i.test(window.location.pathname);
/**
 * @param user
 * @param track
 * @param {SRConfig} config
 * @return {JSX.Element}
 * @constructor
 */

var Act33 = function Act33(_ref) {
  var _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      _ref$track = _ref.track,
      track = _ref$track === void 0 ? noop : _ref$track,
      config = _ref.config;
  var language = getLanguage(config);
  var Body = language.Body,
      Intro = language.Intro;
  useEffect(function () {
    track(trackingOnMountVariables[ACTIVATION_HAS_ACCESS]({
      /* eslint-disable */
      identity_accountid: user.accountId
      /* eslint-enable */

    }));
  }, [user, track]);

  var handleLogoff = function handleLogoff() {
    track(trackingLogOffVariables[ACTIVATION_HAS_ACCESS]({
      /* eslint-disable */
      identity_accountid: user.accountId
      /* eslint-enable */

    }));
  };

  return /*#__PURE__*/React.createElement(AboPaper, null, /*#__PURE__*/React.createElement(Header, {
    title: language.header,
    config: config
  }), Body ? /*#__PURE__*/React.createElement(Body, {
    email: user.email
  }) : /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement(Intro, null), getPlatform() === PLATFORM.WEB ? /*#__PURE__*/React.createElement(React.Fragment, null, language.prefix, /*#__PURE__*/React.createElement(LinkText, {
    onClick: handleLogoff,
    rel: "noopener",
    href: URL_LOGOFF + "?goto=" + (!isActivationPage ? window.location.pathname : URL_LOGON)
  }, language.link), language.outro) : /*#__PURE__*/React.createElement(React.Fragemnt, null, language.outroIos)));
};

export default Act33;